module.exports = __webpack_public_path__ + "img/connectplug-logo-branca.8b7c8f3e.png";